import { logger } from "cayo.ui";
import { IAuthResponse } from "./types";

export function getTrueKeys(systemTypes?: { [key: string]: boolean }): string {
  if (!systemTypes) {
    return "";
  }

  return Object.keys(systemTypes)
    .filter((key) => systemTypes[key])
    .join(",");
}

export function validatePrincipalAccountName(name: string, message: string) {
  if (name.length > 120) {
    return message;
  }

  return undefined;
}

export const grantConsentModern = (
  grantUrl: string,
  finishHandler: ((authResponse: IAuthResponse) => void) | undefined
) => {
  const width = Math.min(800, window.screen.width);
  const height = Math.min(600, window.screen.height);
  const x = Math.max((window.screen.width - width) / 2, 0);
  const y = Math.max((window.screen.height - height) / 2, 0);
  const newWindow = window.open(
    grantUrl,
    "Grant consent",
    `height=${height},width=${width},left=` + x + ",top=" + y
  );

  const popupTick = setInterval(() => {
    if (newWindow && newWindow.closed) {
      clearInterval(popupTick);
      if (finishHandler) {
        finishHandler({});
      }
    } else {
      let href;
      try {
        /*
         * Will throw if cross origin,
         * which should be caught and ignored
         * since we need the interval to keep running while on STS UI.
         */
        href = newWindow!.location.href;
        logger.log(href);
        if (href.toLowerCase().startsWith("http")) {
          const authCodeUrl = new URL(href.replace("/#/redirect", "/"));
          logger.log(authCodeUrl.searchParams);

          clearInterval(popupTick);

          if (finishHandler) {
            finishHandler({
              code: authCodeUrl.searchParams.get("code") as string,
              error: authCodeUrl.searchParams.get("error") as string,
              error_description: authCodeUrl.searchParams.get("error_description") as string,
            });
          }

          newWindow?.close();
        }
      } catch (e) {
        logger.log(e);

        return;
      }
    }
  }, 500);
};
